import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forkJoin, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { ManageCartsActions } from '../actions';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { ManageCartsEffectService } from './manage-carts-effects.service';
import { ManageCartsResponse, LegalEntitiesFilterRepsonse, ManageCartsInfo } from '../state/cart-details.state';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';

@Injectable()
export class CartEffects {

  protected logger = inject(LoggerService);

  constructor(
    public actions$: Actions,
    public apiService: ApiService,
    public globalService: GlobalService,
    public manageCartsEffectService: ManageCartsEffectService,
  ) { }

  // Api Call : to get all saved-carts details -> /cart/legalentities
  loadManageCarts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ManageCartsActions.loadManageCarts),
      switchMap(action => this.apiService.getSavedCartsList(action.params)),
      map((data: ManageCartsResponse) => {
        this.globalService.loadingSubject.next(false);
        // review_comment: Fixed, There could be issue with this API call, since we are overriding previous filter-data if any was available
        const payload: ManageCartsInfo = this.manageCartsEffectService.processCartData(data);
        console.log('manageCarts API response:', payload);
        return ManageCartsActions.loadManageCartsSuccess({ payload });
      }),
      catchError((error) => {
        this.globalService.loadingSubject.next(false);
        console.error('Carts Details API call failed', error);
        return of(ManageCartsActions.loadManageCartsFailure({ error: tryNormalizeHttpError(error, this.logger) }));
      })
    )
  );

  // Combined API Call: to get list of legalentities and saved-carts details
  loadManageCartsDataWithFilter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ManageCartsActions.loadManageCartsDataWithFilter), // New action to trigger combined API calls
      switchMap(action =>
        forkJoin({
          legalEntities: this.apiService.getSaveCartFilterList(),
          savedCarts: this.apiService.getSavedCartsList(action.params)
        }).pipe(
          map(({ legalEntities, savedCarts }: { legalEntities: LegalEntitiesFilterRepsonse; savedCarts: ManageCartsResponse }) => {
            if (legalEntities && savedCarts) {
              this.globalService.loadingSubject.next(false);
              const processedCarts: ManageCartsInfo = this.manageCartsEffectService.processCartData(savedCarts, legalEntities);
              return ManageCartsActions.loadManageCartsDataWithFilterSuccess({
                legalEntitiesPayload: legalEntities,
                savedCartsPayload: processedCarts
              });
            } else {
              this.globalService.loadingSubject.next(false);
              console.warn('Combined API calls returned incomplete data', { legalEntities, savedCarts });
              return ManageCartsActions.loadManageCartsDataWithFilterFailure(
                { error: tryNormalizeHttpError(new Error('One of the Two api call didnt get respone'), this.logger) }
              );
            }
          }),
          catchError(error => {
            this.globalService.loadingSubject.next(false);
            console.error('Combined API calls failed', error);
            return of(ManageCartsActions.loadManageCartsDataWithFilterFailure({ error: tryNormalizeHttpError(error, this.logger) }));
          })
        )
      )
    )
  );
}
